import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { applyTemplateParams } from 'site-modules/shared/components/lead-form/utils/utils';
import { LeadFormMarkdownView } from 'site-modules/shared/components/lead-form/lead-form-markdown-view/lead-form-markdown-view';

export function VdpEmbeddedHeader({
  config: { text, explainingText, className, tag: Tag = 'div' } = {},
  templateParams = [],
}) {
  return (
    <div className="base-form-header text-gray-darker">
      {text && (
        <Tag className={classNames(className || 'heading-5 mb-0_75')}>{applyTemplateParams(templateParams, text)}</Tag>
      )}
      {explainingText && (
        <div className="mt-0_5 text-gray-darker">
          <LeadFormMarkdownView markdown={explainingText} templateParams={templateParams} />
        </div>
      )}
    </div>
  );
}

VdpEmbeddedHeader.propTypes = {
  config: PropTypes.shape({
    text: PropTypes.string,
    explainingText: PropTypes.string,
    className: PropTypes.string,
    tag: PropTypes.string,
  }),
  templateParams: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })
  ), // dynamic object
};
